import React, { useMemo } from 'react'
import { ReactComponent as CheckIcon } from '@material-design-icons/svg/round/check.svg'
import classNames from 'classnames'

import CloseIcon from 'components/icons/CloseIcon'
import CompareIcon from 'components/icons/CompareIcon'
import DownloadFileIcon from 'components/icons/DownloadFileIcon'
import ZoomMinus from 'components/icons/ZoomMinus'
import ZoomPlus from 'components/icons/ZoomPlus'
import useSave from 'hooks/useSave'

import c from './LightBoxHeader.module.scss'

interface LightBoxHeaderProps {
  imageUrl: string
  scale: number
  setScale: (value: number) => void
  isCompare: boolean
  compareHandler: () => void
  sourceUrl?: string
  resetControls: () => void
  onCloseRequest: () => void
}

function LightBoxHeader({
  imageUrl,
  scale,
  setScale,
  isCompare,
  compareHandler,
  sourceUrl = '',
  onCloseRequest,
  resetControls,
}: LightBoxHeaderProps) {
  const { isSaved, handleSave } = useSave(imageUrl)

  const saveIcon = useMemo(() => {
    return isSaved ? (
      <CheckIcon width={24} height={24} style={{ fill: 'white' }} />
    ) : (
      <DownloadFileIcon width={24} height={24} />
    )
  }, [isSaved])

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className={c.header}
      onClick={(event) => event.stopPropagation()}
      role="button"
      tabIndex={0}
    >
      {sourceUrl && (
        <button
          type="button"
          onClick={() => {
            compareHandler()
            resetControls()
          }}
        >
          <span
            className={classNames({
              [c.iconSetting]: true,
              [c.active]: isCompare,
            })}
          >
            <CompareIcon />
          </span>
        </button>
      )}
      <button type="button" onClick={handleSave}>
        <span className={c.iconSetting}>{saveIcon}</span>
      </button>
      {!isCompare && (
        <>
          <button
            type="button"
            disabled={scale >= 10}
            onClick={() => setScale(scale + 0.2)}
            className={c.iconButton}
          >
            <span className={c.iconSetting}>
              <ZoomPlus />
            </span>
          </button>
          <button
            type="button"
            disabled={scale <= 0.8}
            onClick={() => setScale(scale - 0.2)}
            className={c.iconButton}
          >
            <span className={c.iconSetting}>
              <ZoomMinus />
            </span>
          </button>
        </>
      )}
      <button type="button" onClick={onCloseRequest}>
        <span className={c.iconSetting}>
          <CloseIcon />
        </span>
      </button>
    </div>
  )
}

export default LightBoxHeader
